import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politica-pago',
  templateUrl: './politica-pago.component.html',
  styleUrls: ['./politica-pago.component.sass']
})
export class PoliticaPagoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
